import {
    SUPPORTER_LIST_RECEIVE_SUPPORTERS,
    SUPPORTER_LIST_PAGINATE,
    SUPPORTER_LIST_SEARCH_STRING_CHANGE,
    SUPPORTER_LIST_STATES_FILTER_CHANGE,
    SUPPORTER_LIST_PERIODS_FILTER_CHANGE
} from '../config/actions';
import SupporterListHelper from '../helpers/supporterListHelper';

let defaultState = {
    pagination: {
        entrysPerPage: 15,
        currentPage: 0
    },
    searchString: '',
    supporters: [],
    availableProjects: [],
    visibleSupportersAmount: 0,
    availableStates: [],
    availablePeriods: [],
    statesFilter: [],
    periodsFilter: []
};

const supporterListReducer = (state = defaultState, action) => {
    let visibleSupporters, visibleSupportersAmount, supporters;
    switch (action.type) {
        case(SUPPORTER_LIST_RECEIVE_SUPPORTERS):
            SupporterListHelper.filter(action.data.supporters, state.searchString, state.statesFilter, state.periodsFilter);
            visibleSupporters = JSON.parse(JSON.stringify(action.data.supporters)).filter(function (supporter) {
                return supporter.visible
            });
            visibleSupportersAmount = visibleSupporters ? visibleSupporters.length : 0;
            return Object.assign({}, state, {
                supporters: action.data.supporters,
                availableProjects: action.data.availableProjects,
                availableStates: action.data.availableStates,
                visibileSupportersAmount: visibleSupportersAmount,
                availablePeriods: SupporterListHelper.findAvailablePeriods(action.data.supporters),
                pagination: {
                    currentPage: 0,
                    entrysPerPage: state.pagination.entrysPerPage
                }
            });
        case(SUPPORTER_LIST_PAGINATE):
            let newPage = state.pagination.currentPage + action.offset;
            if (newPage < 0) newPage = 0;
            let maxPage = Math.ceil(state.supporters.length / state.pagination.entrysPerPage) - 1;
            if (newPage > maxPage) newPage = maxPage;
            return Object.assign({}, state, {
                pagination: {
                    entrysPerPage: state.pagination.entrysPerPage,
                    currentPage: newPage,
                }
            });
        case(SUPPORTER_LIST_SEARCH_STRING_CHANGE):
            supporters = JSON.parse(JSON.stringify(state.supporters));
            supporters = SupporterListHelper.filter(supporters, action.searchString, state.statesFilter, state.periodsFilter);
            visibleSupporters = JSON.parse(JSON.stringify(supporters)).filter(function (supporter) {
                return supporter.visible
            });
            visibleSupportersAmount = visibleSupporters ? visibleSupporters.length : 0;
            return Object.assign({}, state, {
                supporters: supporters,
                searchString: action.searchString,
                visibileSupportersAmount: visibleSupportersAmount,
                pagination: {
                    currentPage: 0,
                    entrysPerPage: state.pagination.entrysPerPage
                }
            });
        case SUPPORTER_LIST_STATES_FILTER_CHANGE:
            supporters = JSON.parse(JSON.stringify(state.supporters));
            supporters = SupporterListHelper.filter(supporters, state.searchString, action.statesFilter, state.periodsFilter);
            visibleSupporters = JSON.parse(JSON.stringify(supporters)).filter(function (supporter) {
                return supporter.visible
            });
            visibleSupportersAmount = visibleSupporters ? visibleSupporters.length : 0;
            return Object.assign({}, state, {
                supporters: supporters,
                visibileSupportersAmount: visibleSupportersAmount,
                statesFilter: action.statesFilter,
                pagination: {
                    currentPage: 0,
                    entrysPerPage: state.pagination.entrysPerPage
                }
            });
        case SUPPORTER_LIST_PERIODS_FILTER_CHANGE:
            supporters = JSON.parse(JSON.stringify(state.supporters));
            supporters = SupporterListHelper.filter(supporters, state.searchString, state.statesFilter, action.periodsFilter);
            visibleSupporters = JSON.parse(JSON.stringify(supporters)).filter(function (supporter) {
                return supporter.visible
            });
            visibleSupportersAmount = visibleSupporters ? visibleSupporters.length : 0;
            return Object.assign({}, state, {
                supporters: supporters,
                visibileSupportersAmount: visibleSupportersAmount,
                periodsFilter: action.periodsFilter,
                pagination: {
                    currentPage: 0,
                    entrysPerPage: state.pagination.entrysPerPage
                }
            });
        default:
            return state
    }
}
export default supporterListReducer;